import React from 'react';

const ApplicantForm = () => (
  <div style={{
    maxWidth: '600px',
    margin: '4rem auto',
    padding: '2rem',
    background: '#fffbe7',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    textAlign: 'center'
  }}>
    <h2 style={{ color: '#c0392b', marginBottom: '1.5rem' }}>Notice</h2>
    <p style={{ fontSize: '1.2rem', color: '#333', marginBottom: '1.5rem' }}>
      The application form has moved! If you reached this page by mistake or through an old link, please click the button below to access the new application portal.
    </p>
    <a
      href="https://tampazakahapplications.netlify.app/signin"
      style={{
        display: 'inline-block',
        padding: '0.75rem 2rem',
        background: '#3498db',
        color: '#fff',
        borderRadius: '6px',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        textDecoration: 'none',
        marginBottom: '1.5rem'
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      Go to Application Portal
    </a>
    <p style={{ fontSize: '1rem', color: '#555', marginTop: '1.5rem' }}>
       Please use the <b>Requesting Assistance</b> tab to access your account and submit your application.
    </p>
  </div>
);

export default ApplicantForm;